// @flow
import React from 'react';
import { Box, Typography } from '@material-ui/core';

export default function NutrientItem({ label, value, unit }: Props) {
    const displayValue = value === 0 ? '-' : value;
    const shouldShowUnit = unit && value !== 0;

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            margin={0.5}
            flex={1}
        >
            <Typography
                style={{
                    fontSize: 12,
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    flex: 1
                }}
            >
                {label}
            </Typography>
            <Box display="flex" flexDirection="row" alignItems="baseline">
                <Typography
                    style={{
                        fontSize: 12,
                        fontWeight: 700,
                        textTransform: 'uppercase'
                    }}
                >
                    {displayValue}
                </Typography>
                {shouldShowUnit && (
                    <Typography
                        style={{
                            fontSize: 10,
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            marginLeft: 2
                        }}
                    >
                        {unit}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}



// WEBPACK FOOTER //
// ./src/view/calendar/components/NutrientItem.jsx